// extracted by mini-css-extract-plugin
export var completeFlagIcon = "wD8IY";
export var flagIcon = "GR8ZG";
export var flagIconUnfilled = "ARgeA";